import { Search, ExternalLink } from 'lucide-react';
import { ExpandableSection } from '@/components/expandable-section';

interface SearchResult {
  title: string;
  url: string;
  snippet?: string;
}

interface SearchBlockProps {
  query?: string;
  count: number;
  results?: SearchResult[];
  defaultExpanded?: boolean;
}

export function SearchBlock({ query, count, results, defaultExpanded = false }: SearchBlockProps) {
  return (
    <ExpandableSection
      title={`搜索到 ${count} 个结果`}
      icon={<Search size={14} />}
      defaultExpanded={defaultExpanded}
      variant="subtle"
    >
      <div className="space-y-2">
        {query && (
          <p className="text-xs text-muted-foreground">
            搜索关键词：<span className="text-foreground">{query}</span>
          </p>
        )}
        {results && results.length > 0 && (
          <div className="space-y-2">
            {results.map((result, idx) => (
              <a
                key={idx}
                href={result.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 rounded-md border border-border/30 bg-muted/20 p-2 transition-colors hover:border-primary/40 hover:bg-primary/5"
              >
                <ExternalLink size={12} className="mt-0.5 shrink-0 text-muted-foreground" />
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-foreground line-clamp-1">{result.title}</p>
                  {result.snippet && (
                    <p className="mt-0.5 text-[11px] text-muted-foreground line-clamp-2">{result.snippet}</p>
                  )}
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </ExpandableSection>
  );
}
